export default "__VITE_ASSET__DtxVkM3g__"